import { Routes } from '@angular/router';
import { ChainLevelSidebarLayoutComponent } from '../_layouts/chain-level-layout/chain-level-sidebar-layout/chain-level-sidebar-layout.component';

export const CHAIN_LEVEL_LAYOUT_ROUTES: Routes = [
  {
    path: '',
    component: ChainLevelSidebarLayoutComponent,
    children: [
      {
        path: 'access-controller',
        loadChildren: () =>
          import('../_pages/configure/access-controller/access-controller.module').then(
            (m) => m.AccessControllerModule,
          ),
      },
      {
        path: '**',
        redirectTo: 'access-controller',
      }
    ],
  },
];
